// pages/ProposalDocuments.tsx

import { Nav } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import BulkProposalGenerator from "../components/proposalDocuments/bulk/bulkProposalGenerator";
import ProposalDocumentForm from "../components/proposalDocuments/proposalDocumentForm";
import { ProposalDocumentProvider } from "../components/proposalDocuments/proposalDocumentsContext";
import { useUserGroups } from "../hooks/authHooks";

const SINGLE_GROUPS = ["ProposalDocGenerate", "ProposalDocDownload", "GlobalAdmin"];
const BULK_GROUPS = ["ProposalDocGenerateBulk", "GlobalAdmin"];

type ProposalTab = "single" | "bulk";

const ProposalDocuments: React.FC = () => {
  const userGroups = useUserGroups();
  const canSingle = SINGLE_GROUPS.some((g) => userGroups.includes(g));
  const canBulk = BULK_GROUPS.some((g) => userGroups.includes(g));
  const location = useLocation();
  const navigate = useNavigate();

  // The tab lives in the URL hash (#bulk) so a refresh or shared link lands on it
  const activeTab: ProposalTab = location.hash === "#bulk" ? "bulk" : "single";
  const setActiveTab = (tab: ProposalTab) => {
    navigate({ hash: tab === "bulk" ? "bulk" : "" }, { replace: true });
  };

  const single = (
    <ProposalDocumentProvider>
      <ProposalDocumentForm />
    </ProposalDocumentProvider>
  );

  // Only show tabs when there's actually a choice to make
  if (!canBulk) return single;
  if (!canSingle) return <BulkProposalGenerator />;

  // Both stay mounted so switching tabs doesn't throw away form state
  return (
    <>
      <Nav variant="tabs" className="mb-3">
        <Nav.Item>
          <Nav.Link
            active={activeTab === "single"}
            onClick={() => {
              setActiveTab("single");
            }}
          >
            Single
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            active={activeTab === "bulk"}
            onClick={() => {
              setActiveTab("bulk");
            }}
          >
            Bulk
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <div hidden={activeTab !== "single"}>{single}</div>
      <div hidden={activeTab !== "bulk"}>
        <BulkProposalGenerator />
      </div>
    </>
  );
};

export default ProposalDocuments;
